module.exports = __webpack_public_path__ + "static/media/letter_5@3x.fc70ca34.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/letter_5@3x.png
// module id = 591
// module chunks = 0